import { ReactNode } from 'react'

export default function ActivityWrapper({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}): React.ReactElement {
  return (
    <section className={`w-full grow space-y-5 md:space-y-8 flex flex-col items-center ${className ?? ''}`}>
      {children}
    </section>
  )
}
